import { ChangeDetectorRef, Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { MenuItems } from '../../../shared/menu-items/menu-items';
import { Router } from '@angular/router';
import { PermissionKey } from '../../../authentication/models/permission.types';
import { PermissionService } from '../../../services/permission.service';

@Component({
  selector: 'app-vertical-sidebar',
  templateUrl: './vertical-sidebar.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VerticalAppSidebarComponent implements OnDestroy {
  public config: PerfectScrollbarConfigInterface = {};
  public UserData: any;

  public mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  public status: boolean = true;

  public itemSelect: number[] = [];
  public parentIndex: number = 0;
  public childIndex: number = 0;

  public constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private readonly router: Router,
    public readonly menuItems: MenuItems,
    private readonly sidenav: MatSidenav,
    public readonly permission: PermissionService
  ) {
    const raw = localStorage.getItem('authUserInformation');
    this.UserData = raw != null ? JSON.parse(raw) : null;

    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  public setClickedRow(i: number, j: number): void {
    this.parentIndex = i;
    this.childIndex = j;
  }

  public subclickEvent(): void {
    this.status = true;
  }

  public scrollToTop(): void {
    document.querySelector('.page-wrapper')?.scroll({
      top: 0,
      left: 0
    });
  }

  public closeSidenav(): void {
    this.sidenav.close();
  }

  public ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  // Show if no permissions specified, otherwise require any()
  public isVisible(required?: PermissionKey[]): boolean {
    if (required == null || required.length === 0) {
      return true;
    }
    return this.permission.any(required);
  }

  // For "sub" parents: show only if at least one child is visible
  public hasVisibleChildren(menuitem: any): boolean {
    if (menuitem == null) {
      return false;
    }
    if (menuitem.children == null || menuitem.children.length === 0) {
      return false;
    }
    for (let i = 0; i < menuitem.children.length; i++) {
      if (this.isVisible(menuitem.children[i].visibleFor) === true) {
        return true;
      }
    }
    return false;
  }

  public logout(): void {
    localStorage.clear();
    this.router.navigateByUrl('authentication/login');
  }
}
